import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconListNumbers';
/** Renders an SVG icon. */
const SvgListNumbers = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13 7a1 1 0 0 1 1-1h13a1 1 0 0 1 0 2H14a1 1 0 0 1-1-1m0 9a1 1 0 0 1 1-1h13a1 1 0 0 1 0 2H14a1 1 0 0 1-1-1m0 9a1 1 0 0 1 1-1h13a1 1 0 0 1 0 2H14a1 1 0 0 1-1-1M8.394 4.362A.75.75 0 0 1 8.75 5v3.25H9a.75.75 0 1 1 0 1.5H7a.75.75 0 0 1 0-1.5h.25V6.207a.75.75 0 0 1-.585-1.378l1-.5a.75.75 0 0 1 .73.033Zm-.13 10.388a.49.49 0 0 0-.435.269l-.158.316a.75.75 0 1 1-1.342-.67l.159-.317a1.99 1.99 0 0 1 1.776-1.098h.044a1.943 1.943 0 0 1 .721 3.746l-.634.254H9.5a.75.75 0 1 1 0 1.5H7a.75.75 0 0 1-.75-.75c0-.91.555-1.73 1.4-2.068l.822-.329a.443.443 0 0 0-.164-.853zM6.25 23a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .53 1.28l-.853.853.183.123c.556.37.89.994.89 1.662 0 .874-.708 1.582-1.582 1.582h-.834a1.583 1.583 0 0 1-1.584-1.583V26a.75.75 0 0 1 1.5 0v.167c0 .046.037.083.083.083h.835a.08.08 0 0 0 .082-.082.5.5 0 0 0-.222-.415l-.944-.629a.75.75 0 0 1-.114-1.154l.22-.22H7a.75.75 0 0 1-.75-.75"
      />
    </svg>
  );
};
SvgListNumbers.displayName = displayName;
export default SvgListNumbers;
